module.exports = "/_next/static/images/christopher-warren-050c055540bb7a3b48ac5ffc464337fe.png";